import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ValidationService } from '../../../../../shared/providers/validation.service';
import { PropertyListingService } from '../../../../../shared/providers/property-listing.service';
import { OfferComparisonGroupData, OfferComparisonGroup } from '../../../../../shared/models/OfferComparisonList';
import { AuthenticationService } from '../../../../../shared/auth/authentication.service';
import { LoaderService } from '../../../../../shared/providers/loader.service';
import * as Highcharts from 'highcharts';
import { response } from 'express';
if (typeof Highcharts === 'object') {
  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
@Component({
  selector: 'app-property-offer-comparison',
  templateUrl: './offer-comparison.component.html',
  styleUrls: ['./offer-comparison.component.css']
})
export class OfferComparisonComponent implements OnInit {
  @Input() propertyId = 0;
  offerComparisonChart: any;
  @Input() IsPortfolio: boolean = false;
  @Input() isFromPortfolio: boolean = false;
  public BarProspectsStatus: any = {}
  constructor(public Validation: ValidationService, private propertyListing: PropertyListingService, private authentication: AuthenticationService, private Loader: LoaderService) { }
  user: any;
  period = 3;
  offerComparisonList: OfferComparisonGroup[];
  sellerOfferComparisonGroupData: OfferComparisonGroupData[] = [];
  @ViewChild('chartContainer') chartContainer: ElementRef;
  offers: any;
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: any = {};

  ngOnInit() {
    this.Loader.display(true);
    this.user = this.authentication.user;
    if (this.IsPortfolio) {
      this.propertyListing.GetPortfolioOfferComparison(this.propertyId).subscribe(res => {
        this.offers = res;
      });
    }
    else {
      this.LoadOfferChart(this.propertyId, this.period);
    }
  }
  periodChange() {
    this.LoadOfferChart(this.propertyId, this.period);
  }

  LoadOfferChart(propertyId: number, period: number) {
    this.propertyListing.GetOfferComparison(0, propertyId, 0, period).subscribe(res => {
      this.offerComparisonList = res;
      this.sellerOfferComparisonGroupData = [];
      let chartStatus = false;
      this.offerComparisonList.forEach(item => {
        var sellerOfferComparisonGroupDataObj = new OfferComparisonGroupData;
        sellerOfferComparisonGroupDataObj.name = item.Name;
        chartStatus = true;
        var valueList: number[][];
        var capRateValues: number[];
        var offerPriceValues: number[];
        item.Data.forEach(it => {
          var multi: number[][] = [[it.OfferPrice, it.CapRate]];
          var cap: number[] = [it.CapRate];
          var price: number[] = [it.OfferPrice];

          if (valueList != undefined) {
            valueList = valueList.concat(multi);
            capRateValues = capRateValues.concat(cap);
            offerPriceValues = offerPriceValues.concat(price);
          }
          else {
            valueList = multi;
            capRateValues = cap;
            offerPriceValues = price;
          }
        });
        sellerOfferComparisonGroupDataObj.color = '#198FDE';
        sellerOfferComparisonGroupDataObj.data = valueList;
        this.sellerOfferComparisonGroupData.push(sellerOfferComparisonGroupDataObj);
        if (capRateValues != null && capRateValues.length > 0) {
          if (capRateValues.findIndex(c => c > 0) > -1) {
            this.bindOfferChart();
          }
          else {
            this.bindChart(offerPriceValues);
          }
        }
        else {
          this.bindOfferChart();
        }
      });
      if (!chartStatus) {
        this.bindOfferChart();
      }
      this.Loader.display(false);
    });
  }


  bindOfferChart() {
    let that = this;
    var originalColor;
    this.offerComparisonChart = {
      chart: {
        type: 'scatter',
        renderTo: 'container'
      },
      //options: {
      //  colors: ['#198FDE']
      //},
      title: {
        text: ''
      },
      xAxis: {
        //type: 'datetime',
        labels:
        {
          rotation: -40,

          formatter: function () {
            return '$ ' + that.Validation.commaFormat(this.value);

          },
        },
        type: 'logarithmic',
        minorTickInterval: 0.1,
      },
      yAxis: [{
        title: {
          text: ''
        },
        opposite: false,
        labels:
        {
          enabled: true,
          formatter: function () {
            return Highcharts.numberFormat(this.value, 2) + '%';
          }
        },
        type: 'logarithmic',
        minorTickInterval: 1,
        allowDecimals: true,
      }],
      legend: {
        enabled: false,
        itemStyle: {
          fontWeight: 'normal'
        }
      },
      credits: {
        enabled: false
      },
      tooltip: {
        headerFormat: '',
        pointFormatter: function () {
          var point = this;

          let value = point.y;
          return '<span style="font-size:15px;color:' + point.color + '">Offer Price:$' + that.Validation.commaFormat(point.x) + '</span><table><tr><td style="padding:0"> Cap Rate:</td><td style="padding:0"><b>' + value + '%</b></td></tr>';
        },
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        series: {

          marker: {
            enabled: true,
            radius: 5,
          }

        },
        scatter: {
          allowOverlap: true,
          padding: 2
        }
      },
      series: this.sellerOfferComparisonGroupData
    }
    Highcharts.chart('container', this.offerComparisonChart);
  }

  bindChart(offers: any) {
    let that = this;
    let Xaxis = [];
    let Value = [] = offers.map(o => o);
    let minimum = offers.reduce((a, b) => Math.min(a, b));
    minimum = minimum > 1 ? (minimum - 1) : 0;
    this.BarProspectsStatus = {
      chart: {
        type: 'column',
        title: ''
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: Xaxis,
        crosshair: false,
        title: {
          text: ''
        },
        labels: {
          enabled: false
        }
      },
      yAxis: {
        crosshair: false,
        minorTickInterval: 1,
        title: {
          text: ''
        },
        allowDecimals: false,
       // min: minimum,
        labels:
        {
          formatter: function () {
            return '$ ' + that.Validation.commaFormat(this.value);

          },
        },
        type: 'logarithmic',
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          }
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      tooltip: {
        headerFormat: '',
        pointFormatter: function () {
          var point = this;

          let value = point.y;
          return '<span style="font-size:15px;color:' + point.color + '">Offer Price:$' + that.Validation.commaFormat(value) + '</span>';
        },
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      series: [{
        name: 'Status',
        data: Value,
        color: '#198FDE'
      }]
    };
    Highcharts.chart('container', this.BarProspectsStatus);
  }

}

